import { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { FC, useEffect, useState } from 'react';
import { Checkbox } from 'components/atoms/checkbox';
import { BooleanField as BooleanFieldT } from 'components/organisms/tasks/fields';

interface BooleanFieldProps {
  field: BooleanFieldT;
  disabled?: boolean;
  onChange?: (selected: boolean, field: BooleanFieldT) => void;
}

export const BooleanField: FC<BooleanFieldProps> = ({
  field,
  disabled,
  onChange,
}) => {
  const { value } = field;
  const [state, setState] = useState<boolean | undefined>();

  useEffect(() => {
    setState(value);
  }, [value]);

  const commit = (e: CheckboxChangeEvent) => {
    const {
      target: { checked },
    } = e;

    setState(checked);
    if (onChange) {
      onChange(checked, field);
    }
  };

  return (
    <Checkbox
      checked={state}
      disabled={disabled}
      onChange={commit}
      data-cy={`right.content.${field.fieldLabel}`}
    />
  );
};
